module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_a/aoj_a-4-6eb3a890110fe41c43e2c23a8b079a44.jpg";